// extracted by mini-css-extract-plugin
module.exports = {"Bio":"Bio_Bio__KvdO2","FullWidthBio":"Bio_FullWidthBio__150mr","FullWidthBioBlockQuote":"Bio_FullWidthBioBlockQuote__2ojn8"};